import React, { useState, useEffect } from 'react';
import axios from 'axios';

function AdminTicketPage() {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [messages, setMessages] = useState([]);
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const res = await axios.get('https://www.sharedvision-partners.online/v1/API/Admin/all.php');
      setTickets(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const selectTicket = async (ticket) => {
    setSelectedTicket(ticket);
    setError('');
    setMessages([]);
    try {
      const res = await axios.get(`https://www.sharedvision-partners.online/v1/API/Admin/view.php?ticket_id=${ticket.id}`);
      setMessages(res.data);
    } catch (err) {
      setError('Failed to load messages');
    }
  };

  const sendReply = async () => {
    if (!reply.trim()) return;
    setLoading(true);
    setError('');
    try {
      await axios.post('https://www.sharedvision-partners.online/v1/API/Admin/reply.php', {
        ticket_id: selectedTicket.id,
        sender: 'admin',
        message: reply,
      });
      setReply('');
      const res = await axios.get(`https://www.sharedvision-partners.online/v1/API/Admin/view.php?ticket_id=${selectedTicket.id}`);
      setMessages(res.data);
      fetchTickets();
    } catch (err) {
      setError('Failed to send reply');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        * {
          box-sizing: border-box;
        }
        body {
          margin: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
            Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          background: #f9fafb;
          color: #333;
        }
        .container {
          display: flex;
          gap: 2rem;
          padding: 1rem 2rem;
          height: 100vh;
          max-height: 100vh;
        }
        @media (max-width: 768px) {
          .container {
            flex-direction: column;
            height: auto;
            padding: 1rem;
          }
        }
        .tickets-list {
          flex: 1;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
          overflow-y: auto;
          max-height: 100%;
          display: flex;
          flex-direction: column;
        }
        .tickets-list h2 {
          margin: 1rem;
          border-bottom: 1px solid #eee;
          padding-bottom: 0.5rem;
          font-weight: 600;
          font-size: 1.25rem;
          color: #111827;
        }
        .tickets-list ul {
          list-style: none;
          padding: 0 1rem 1rem 1rem;
          margin: 0;
          flex-grow: 1;
          overflow-y: auto;
        }
        .ticket-item {
          padding: 0.75rem 1rem;
          border-radius: 6px;
          margin-bottom: 0.5rem;
          cursor: pointer;
          transition: background-color 0.2s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1rem;
          color: #374151;
          border: 1px solid transparent;
        }
        .ticket-item:hover {
          background-color: #f3f4f6;
        }
        .ticket-item.selected {
          background-color: #2563eb;
          color: white;
          font-weight: 600;
          border-color: #1e40af;
        }
        .ticket-status {
          font-size: 0.875rem;
          font-weight: 500;
          padding: 0.15rem 0.5rem;
          border-radius: 12px;
          background-color: #e0e7ff;
          color: #3730a3;
          white-space: nowrap;
          user-select: none;
        }
        .ticket-status.open {
          background-color: #d1fae5;
          color: #065f46;
        }
        .ticket-status.closed {
          background-color: #fee2e2;
          color: #991b1b;
        }
        .messages-panel {
          flex: 2;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgb(0 0 0 / 0.1);
          display: flex;
          flex-direction: column;
          max-height: 100%;
          padding: 1rem 1.5rem;
        }
        @media (max-width: 768px) {
          .messages-panel {
            max-height: none;
            margin-top: 1rem;
          }
        }
        .messages-panel h2 {
          margin: 0 0 1rem 0;
          font-weight: 700;
          font-size: 1.5rem;
          color: #111827;
        }
        .messages-container {
          flex-grow: 1;
          overflow-y: auto;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          padding: 1rem;
          background: #f9fafb;
          margin-bottom: 1rem;
          min-height: 200px;
        }
        .message {
          margin-bottom: 1.25rem;
          padding-bottom: 0.5rem;
          border-bottom: 1px solid #e5e7eb;
        }
        .message:last-child {
          border-bottom: none;
          margin-bottom: 0;
        }
        .message strong {
          display: block;
          margin-bottom: 0.25rem;
          font-weight: 600;
          color: #2563eb;
        }
        .message p {
          margin: 0 0 0.25rem 0;
          line-height: 1.4;
          white-space: pre-wrap;
          color: #374151;
        }
        .message small {
          font-size: 0.75rem;
          color: #6b7280;
        }
        textarea {
          width: 100%;
          border-radius: 6px;
          border: 1px solid #d1d5db;
          padding: 0.75rem;
          font-size: 1rem;
          resize: vertical;
          transition: border-color 0.2s ease;
          font-family: inherit;
          min-height: 80px;
        }
        textarea:focus {
          outline: none;
          border-color: #2563eb;
          box-shadow: 0 0 0 2px rgb(59 130 246 / 0.3);
        }
        button {
          margin-top: 0.5rem;
          padding: 0.6rem 1.25rem;
          font-size: 1rem;
          font-weight: 600;
          color: white;
          background-color: #2563eb;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: background-color 0.2s ease;
          align-self: flex-start;
          user-select: none;
        }
        button:disabled {
          background-color: #93c5fd;
          cursor: not-allowed;
        }
        .error-msg {
          margin-top: 0.75rem;
          color: #dc2626;
          font-weight: 600;
        }
        .no-selection {
          font-size: 1.125rem;
          color: #6b7280;
          margin-top: 2rem;
          text-align: center;
          flex-grow: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>

      <div className="container" role="main" aria-label="Admin Ticket Management">
        <aside className="tickets-list" aria-label="All Tickets">
          <h2>All Tickets</h2>
          <ul>
            {tickets.length === 0 && <li style={{ padding: '1rem', color: '#6b7280' }}>No tickets found.</li>}
            {tickets.map((t) => (
              <li
                key={t.id}
                className={`ticket-item ${selectedTicket?.id === t.id ? 'selected' : ''}`}
                onClick={() => selectTicket(t)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') selectTicket(t);
                }}
                aria-current={selectedTicket?.id === t.id ? 'true' : 'false'}
              >
                <span>{t.subject}</span>
                <span
                  className={`ticket-status ${t.status.toLowerCase() === 'open' ? 'open' : 'closed'}`}
                  aria-label={`Status: ${t.status}`}
                >
                  {t.status}
                </span>
              </li>
            ))}
          </ul>
        </aside>

        <section className="messages-panel" aria-label="Selected Ticket Messages">
          {selectedTicket ? (
            <>
              <h2>{selectedTicket.subject}</h2>
              <div className="messages-container" aria-live="polite" aria-relevant="additions">
                {messages.length === 0 ? (
                  <p style={{ color: '#6b7280', fontStyle: 'italic' }}>No messages yet.</p>
                ) : (
                  messages.map((m) => (
                    <div key={m.id} className="message">
                      <strong>{m.sender === 'admin' ? 'Admin' : 'User'}</strong>
                      <p>{m.message}</p>
                      <small>{new Date(m.created_at).toLocaleString()}</small>
                    </div>
                  ))
                )}
              </div>

              <textarea
                placeholder="Type your reply..."
                value={reply}
                onChange={(e) => setReply(e.target.value)}
                rows={3}
                aria-label="Reply message input"
                disabled={loading}
              />
              <button
                onClick={sendReply}
                disabled={loading || !reply.trim()}
                aria-disabled={loading || !reply.trim()}
                aria-live="polite"
              >
                {loading ? 'Sending...' : 'Send Reply'}
              </button>
              {error && <p className="error-msg" role="alert">{error}</p>}
            </>
          ) : (
            <p className="no-selection">Select a ticket to view details</p>
          )}
        </section>
      </div>
    </>
  );
}

export default AdminTicketPage;
